export default [
    {name: 'Male', value: 1},
    {name: 'Female', value: 2},
    {name: 'Other', value: 927940000},
    {name: 'Prefer not to say', value: 927940001},
];